<template>
    <div>
        <v-dialog
            v-model="computedClutchKit.show"
            :persistent="true"
            max-width="800px"
            :scrollable="true"
        >
            <v-card class="modal--tips4y modal-kit-identifier">
                <v-card-title class="headline d-flex justify-center">
                    <h2 class="mb-0">
                        {{ $t("b2b.estimation.search-service.select-group") }}
                    </h2>
                </v-card-title>

                <v-card-text>
                    <div v-for="(groups, index) in options" :key="index">
                        <v-radio-group
                            v-model="groups.selected"
                            column
                            hide-details
                        >
                            <div
                                class="mb-2"
                                v-for="(parts, index2) in groups.parts"
                                :key="index2"
                            >
                                <v-radio
                                    :label="parts.name"
                                    :value="parts.value"
                                    @click="() => clickRadio(index)"
                                ></v-radio>
                            </div>
                        </v-radio-group>
                        <hr v-if="index + 1 !== options.length" />
                    </div>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <div class="ml-2">
                        <v-btn
                            class="primary-button"
                            text
                            @click="handleCloseKitModal"
                            :disabled="validateSaveButton"
                        >
                            <span style="text-transform: capitalize">{{
                                $t("b2b.estimation.search-service.continue")
                            }}</span>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            changing: false,
            triggered: false,
            show: this.$store.getters["budget/getStateOfClutchKit"].show,
            options: this.$store.getters["budget/getStateOfClutchKit"].options,
        };
    },

    watch: {
        options: {
            handler: function (newValue, oldValue) {
                if (!this.triggered) {
                    this.changing = true;
                }
                this.triggered = false;

                this.handleUpdateClutchKitData(newValue);
            },
            deep: true,
            immediate: true,
        },
    },

    computed: {
        computedClutchKit() {
            const getStateOfKit =
                this.$store.getters["budget/getStateOfClutchKit"];
            this.options = getStateOfKit.options;
            return getStateOfKit;
        },
        validateSaveButton() {
            const findSomeSelected = this.options.find(
                (opt) => opt.selected !== null
            );
            return !findSomeSelected;
        },
    },

    methods: {
        clickRadio(index) {
            this.triggered = false;
            setTimeout(() => {
                if (!this.changing) {
                    this.options[index].selected = null;
                    this.triggered = true;
                }
                this.changing = false;
            }, 100);
        },
        handleCloseKitModal() {
            const payload = {
                show: false,
                data: this.computedClutchKit.data,
                options: this.computedClutchKit.options,
                removePartIDs: this.computedClutchKit.removePartIDs,
            };
            this.$store.commit("budget/setStateOfClutchKit", payload);
        },
        handleUpdateClutchKitData(newValue) {
            const removePartIDs = [];
            this.options.forEach((option) => {
                option.parts.forEach((part) => {
                    if (part.value !== option.selected) {
                        removePartIDs.push(part.value);
                    }
                });
            });

            const payload = {
                show: this.computedClutchKit.show,
                data: newValue,
                options: this.options,
                removePartIDs: removePartIDs,
            };
            this.$store.commit("budget/setStateOfClutchKit", payload);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-kit-identifier {
    .v-radio {
        label {
            margin-bottom: 0px !important;
        }
    }
}
</style>
